"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var FolderTree_1 = require("components/FolderTree");
var sok_ui_1 = require("@caddigital/sok-ui");
require("./ModelSelector.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ManageModels'), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('saved', 'setSaved', true), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.isOpen &&
            this.props.isOpen !== prevProps.isOpen &&
            this.props.currentProject) {
            this.props.getContent({
                id: this.props.currentProject.rootFolder
            });
        }
        if (!this.props.isOpen && this.props.isOpen !== prevProps.isOpen) {
            this.props.setSaved(true);
        }
        if (this.props.saved &&
            ((this.props.isOpen &&
                this.props.isOpen === prevProps.isOpen &&
                this.props.folderTree.data.tree !== prevProps.folderTree.data.tree &&
                this.props.folderTree.data.tree) ||
                (this.props.isOpen &&
                    this.props.isOpen !== prevProps.isOpen &&
                    this.props.folderTree.data.tree &&
                    this.props.folderTree.data.tree === prevProps.folderTree.data.tree))) {
            var current = this.props.folderTree.data.tree.getNodes().find(function (x) {
                var id = x.getValue().id;
                if (_this.props.selectedRevisions.length === 0) {
                    return id === _this.props.currentRevision.id;
                }
                return _this.props.selectedRevisions.findIndex(function (z) { return z.id === id; }) > -1;
            });
            if (current && !current.getSelected()) {
                this.props.selectItem(current, true);
            }
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isOpen || this.props.isOpen !== nextProps.isOpen) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", null,
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-cubes' }), text: (0, translation_1.getLocalization)('filesPreview/manageModels'), onClick: function () { return props.setIsOpen(!props.isOpen); } }),
    React.createElement(sok_ui_1.Overlay, { isOpen: props.isOpen, onClose: alert },
        React.createElement(sok_ui_1.SideMenu, { className: 'sok-preview-manage-models', isOpen: props.isOpen, docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: function () { return props.setIsOpen(false); } }, (0, translation_1.getLocalization)('filesPreview/manageModels')),
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", null,
                    React.createElement("div", { className: 'help' }, (0, translation_1.getLocalization)('filesPreview/manageModels/help')),
                    props.folderTree.data.status === 'FETCHING' &&
                        !props.folderTree.data.root && (React.createElement("div", { className: 'loading-spinner' },
                        React.createElement(sok_ui_1.LoadingSpinner, null),
                        React.createElement("div", { className: "loadingText" }, (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/fetchingContent')))),
                    props.folderTree.data.tree &&
                        props.folderTree.data.root &&
                        props.currentProject && (React.createElement(FolderTree_1.default, { parentIdentifier: props.currentProject.rootFolderIdentifier, tree: props.folderTree.data.tree, selectItem: function (file, value) {
                            var item = file.getValue();
                            if (item && item.type !== 'FOLDER') {
                                props.setSaved(false);
                                props.selectItem(file, value);
                            }
                        }, changeExpand: props.changeExpand, getContent: props.getContent, expandType: FolderTree_1.ANY_CONTENT })))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement("div", { className: 'button-group left' },
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () {
                            if (props.folderTree.data.tree) {
                                props.folderTree.data.tree.getNodes().forEach(function (x) {
                                    var cur = x.getValue();
                                    if (cur.id === props.currentRevision.id) {
                                        !x.getSelected() && props.selectItem(x, true);
                                        return;
                                    }
                                    if (x.getSelected()) {
                                        props.selectItem(x, false);
                                    }
                                });
                                props.setSelectedRevisions([]);
                            }
                        }, text: (0, translation_1.getLocalization)('filesPreview/manageModels/clearSelection') })),
                React.createElement("div", { className: 'button-group right' },
                    React.createElement(sok_ui_1.Button, { color: 'green', onClick: function () {
                            if (props.folderTree.data.tree) {
                                var revisions = props.folderTree.data.tree
                                    .getNodes()
                                    .filter(function (x) { return x.getSelected(); })
                                    .map(function (x) { return x.getValue(); });
                                if (revisions.length === 0) {
                                    revisions.push(props.currentRevision);
                                }
                                props.setSelectedRevisions(revisions);
                                props.setIsOpen(false);
                            }
                        }, text: (0, translation_1.getLocalization)('buttons/update') }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.setIsOpen(false); }, text: (0, translation_1.getLocalization)('userfront/button/cancel') }))))))); });
